module.exports = __webpack_public_path__ + "img/Jump Casting39.b3499a6b.jpg";